export default __webpack_public_path__ + "static/media/breakout-icon.a9fe1e79.png";